import './HoopsViewerToolbar.css';
import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { Menu as m } from "antd";
import u from "clsx";
import { useMemo as g, useState as T, useCallback as C, useEffect as F } from "react";
import { useTranslation as O } from "react-i18next";
import { DEFAULT_TRANSFORM_DURATION as k } from "./HoopsViewer.consts.mjs";
import { translate as N } from "./HoopsViewer.utils.mjs";
import "./HoopsViewerContext.mjs";
import { useHoopsViewerContext as P, useBundle as x } from "./HoopsViewerContext.hooks.mjs";
import { CuttingPlaneController as D } from "./CuttingPlaneController.mjs";
import { H as A, a as E, b as B, c as j, d as L, e as y, f as z, g as U, h as $, i as q, j as G, k as W, l as X, m as Y, n as Z, o as J, p as K, q as Q, r as ee, s as oe, t as se, u as ne, v as re, w as ie, x as ae, y as te, z as ce, A as le, B as me } from "./HoopsViewerRemoveMeasurementsIcon-CgwjpIWI.js";
const ue = "_wrapper_815pe_1", pe = "_menuItem_815pe_10", we = "_submenuItem_815pe_22", de = "_submenuRow_815pe_38", Ie = "_submenuRowTitle_815pe_41", r = {
  wrapper: ue,
  menuItem: pe,
  submenuItem: we,
  submenuRow: de,
  submenuRowTitle: Ie
}, ge = (R) => {
  const {
    prefix: o = "",
    transformDuration: t = k,
    className: h,
    menuClassName: v,
    menuItemClassName: f,
    menuSubItemClassName: w
  } = R, { api: d, initialized: b } = P(), n = d == null ? void 0 : d.viewer, { model: H, operatorManager: I } = n || {}, a = x(), c = g(() => n ? new D(n, a) : null, [a, n]), s = O(), _ = H ? H.isMeasurable() : !1, [l, M] = T(a.OperatorId.None), p = C(
    (V) => {
      M((S) => S !== V ? V : a.OperatorId.None);
    },
    [a.OperatorId.None]
  );
  return F(() => {
    I && I.set(l, 1);
  }, [I, l]), !n || !b ? null : /* @__PURE__ */ e("div", { className: u(r.wrapper, h), children: /* @__PURE__ */ i(m, { className: v, children: [
    /* @__PURE__ */ e(m.Item, { className: u(r.menuItem, f), children: /* @__PURE__ */ e(
      A,
      {
        initialized: b,
        viewer: n,
        translation: s,
        prefix: o,
        duration: t
      }
    ) }, "1"),
    /* @__PURE__ */ i(
      m.SubMenu,
      {
        className: u(r.submenuItem, w),
        title: /* @__PURE__ */ e(E, { translation: s, prefix: o }),
        children: [
          /* @__PURE__ */ e("div", { className: r.submenuRowTitle, children: N(s, `${o}reset_to_original_view`, "Reset To Original View") }),
          /* @__PURE__ */ i("div", { className: r.submenuRow, children: [
            /* @__PURE__ */ e(B, { viewer: n, translation: s, prefix: o }),
            /* @__PURE__ */ e(j, { viewer: n, translation: s, prefix: o })
          ] }),
          /* @__PURE__ */ e("div", { className: r.submenuRowTitle, children: N(s, `${o}view`, "View") }),
          /* @__PURE__ */ i("div", { className: r.submenuRow, children: [
            /* @__PURE__ */ e(
              L,
              {
                viewer: n,
                translation: s,
                prefix: o,
                duration: t
              }
            ),
            /* @__PURE__ */ e(
              y,
              {
                viewer: n,
                translation: s,
                prefix: o,
                duration: t
              }
            ),
            /* @__PURE__ */ e(
              z,
              {
                viewer: n,
                translation: s,
                prefix: o,
                duration: t
              }
            )
          ] }),
          /* @__PURE__ */ i("div", { className: r.submenuRow, children: [
            /* @__PURE__ */ e(
              U,
              {
                viewer: n,
                translation: s,
                prefix: o,
                duration: t
              }
            ),
            /* @__PURE__ */ e(
              $,
              {
                viewer: n,
                translation: s,
                prefix: o,
                duration: t
              }
            ),
            /* @__PURE__ */ e(
              q,
              {
                viewer: n,
                translation: s,
                prefix: o,
                duration: t
              }
            )
          ] }),
          /* @__PURE__ */ e("div", { className: r.submenuRow, children: /* @__PURE__ */ e(
            G,
            {
              viewer: n,
              translation: s,
              prefix: o,
              duration: t
            }
          ) })
        ]
      },
      "2"
    ),
    /* @__PURE__ */ i(
      m.SubMenu,
      {
        className: u(r.submenuItem, w),
        title: /* @__PURE__ */ e(W, { translation: s, prefix: o }),
        children: [
          /* @__PURE__ */ e(X, { viewer: n, translation: s, prefix: o }),
          /* @__PURE__ */ e(Y, { viewer: n, translation: s, prefix: o }),
          /* @__PURE__ */ e(Z, { viewer: n, translation: s, prefix: o }),
          /* @__PURE__ */ e(J, { viewer: n, translation: s, prefix: o })
        ]
      },
      "3"
    ),
    c ? /* @__PURE__ */ i(
      m.SubMenu,
      {
        className: u(r.submenuItem, w),
        title: /* @__PURE__ */ e(K, { translation: s, prefix: o }),
        children: [
          /* @__PURE__ */ i("div", { className: r.submenuRow, children: [
            /* @__PURE__ */ e(Q, { controller: c, translation: s, prefix: o }),
            /* @__PURE__ */ e(
              ee,
              {
                controller: c,
                translation: s,
                prefix: o
              }
            )
          ] }),
          /* @__PURE__ */ i("div", { className: r.submenuRow, children: [
            /* @__PURE__ */ e(oe, { controller: c, translation: s, prefix: o }),
            /* @__PURE__ */ e(
              se,
              {
                controller: c,
                translation: s,
                prefix: o
              }
            )
          ] }),
          /* @__PURE__ */ i("div", { className: r.submenuRow, children: [
            /* @__PURE__ */ e(ne, { controller: c, translation: s, prefix: o }),
            /* @__PURE__ */ e(
              re,
              {
                controller: c,
                translation: s,
                prefix: o
              }
            )
          ] })
        ]
      },
      "4"
    ) : null,
    _ && /* @__PURE__ */ i(
      m.SubMenu,
      {
        className: u(r.submenuItem, w),
        title: /* @__PURE__ */ e(ie, { translation: s, prefix: o }),
        children: [
          /* @__PURE__ */ i("div", { className: r.submenuRow, children: [
            /* @__PURE__ */ e(
              ae,
              {
                translation: s,
                prefix: o,
                active: l === a.OperatorId.MeasureEdgeLength,
                onClick: p
              }
            ),
            /* @__PURE__ */ e(
              te,
              {
                translation: s,
                prefix: o,
                active: l === a.OperatorId.MeasureFaceFaceDistance,
                onClick: p
              }
            )
          ] }),
          /* @__PURE__ */ i("div", { className: r.submenuRow, children: [
            /* @__PURE__ */ e(
              ce,
              {
                translation: s,
                prefix: o,
                active: l === a.OperatorId.MeasureFaceFaceAngle,
                onClick: p
              }
            ),
            /* @__PURE__ */ e(
              le,
              {
                translation: s,
                prefix: o,
                active: l === a.OperatorId.MeasurePointPointDistance,
                onClick: p
              }
            )
          ] }),
          /* @__PURE__ */ e(
            me,
            {
              translation: s,
              prefix: o,
              onClick: p
            }
          )
        ]
      },
      "5"
    )
  ] }) });
};
export {
  ge as H
};
//# sourceMappingURL=HoopsViewerToolbar-DLrXfwTT.js.map
